import { createSelector } from "@reduxjs/toolkit";
import { MixState } from "../../entities/Mix";
import { RootState } from "../../store/store";

export const getRoot = (state: RootState) => state.mixByFuchs;

export const getMixByFuchsData = createSelector(
  [getRoot],
  (mix: MixState) => mix.data,
);

export const getMixesByFuchs = createSelector(
  [getRoot],
  (mix: MixState) => mix.data.mixes,
);
